
// import { TestItem } from "../../ts/model";

export default {
  props: ['results', 'url', 'colors', 'resultType', 'testDone'],
  // props: {
  //   results: Array || Object,
  //   url: {
  //     type: String,
  //     required: true
  //   },
  //   colors: {
  //     type: Array,
  //     default: () => ["amber", "green", "blue", "lime", "yellow"],
  //     required: false
  //   },
  //   resultType: String,
  // },
  data() {
    return {
      linkResults: {
        type: String,
        default: () => ""
      },
      isStored: false,
    };
  },
  watch: {
    testDone: function (val) {
      if (val && !this.isStored) {
        setTimeout(() => {
          this.scrollToAnchor("testResult")
        }, "100");
        this.saveResults(this.results)
      }
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.id) {
      const id = this.$route.query.id
      //console.log('id', id)
      //const res = this.$decodeBase64(this.$route.query.results);
      const results = this.getResults(id).then(val => {
        this.isStored = true
        this.$emit("update:results", val);
        this.linkResults = `${this.url}?id=${id}`;
      }); //JSON.parse(res);
    }
  },
  methods: {
    scrollToAnchor: function (anchorId) {
      const headerHeight = document.getElementById("header").offsetHeight;
      let element = document.getElementById(anchorId);
      if (element) {
        setTimeout(() => {
          // Вычисляем позицию отступа наверху элемента
          let offset = 0;
          while (element) {
            offset += element.offsetTop - element.scrollTop + element.clientTop;
            element = element.offsetParent;
          }
          // Выполняем плавную прокрутку к якорю
          window.scrollTo({
            top: offset - 200,
            behavior: "smooth",
          });
        }, "100");
      }
    },
    getResults: async function (id) {
      const url = `${this.$config.apiURL}/json/${id}`
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: url,
        retries: 3, // number of retries
        retryDelay: (retryCount) => {
          console.log(`retry attempt: ${retryCount}`);
          return retryCount * 500; // time interval between retries
        },
        headers: {}
      };
      const res = await this.$axios.request(config)
        .then((response) => {
          return response.data
          //console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          console.log('error', error);
        });
      return res
    },
    saveResults: function (value) {
      const url = `${this.$config.apiURL}/json?source=${this.$route.path}`
      //console.log('saveResults', url)
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: url,
        data: value,
        retries: 3, // number of retries
        retryDelay: (retryCount) => {
          console.log(`retry attempt: ${retryCount}`);
          return retryCount * 500; // time interval between retries
        },
        headers: {}
      };
      //console.log('config', config)
      const res = this.$axios.request(config)
        .then((response) => {
          this.linkResults = `${this.url}?id=${response.data.id}`;
          return response.data
        })
        .catch((error) => {
          console.log('error', error);
        });
      //console.log('res', res)
      return res
    },
    copyToClipboard: function () {
      const textToCopy = this.linkResults;
      // Navigator clipboard api needs a secure context (https)
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(textToCopy);
      } else {
        // Use the 'out of viewport hidden text area' trick
        const textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // Move textarea out of the viewport so it's not visible
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";
        document.body.prepend(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
        } catch (error) {
          console.error(error);
        } finally {
          textArea.remove();
        }
      }
    },
  },
};
